import "./style.css";
import { useNavigate } from "react-router-dom";
export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="footer bg-blue-950 text-white px-10 py-12 mt-12">
      <div className="grid md:grid-cols-4 gap-8">
        <div>
          <div className="group-2">
            <span className="footer-logo-text">Global StudyIn</span>
          </div>
          <p className="footer-icon-desc-text">
            Your trusted partner for Global education success. We provide comprehensive guidance and support to help international students achieve their academic goals worldwide.
          </p>
        </div>
        <div className="footer-quick-link-container">
          <h4 className="font-semibold mb-3 footer-section-header-text">
            Quick Links
          </h4>
          <ul className="space-y-1">
            <li className="footer-icon-desc-text cursor-pointer">
              <button onClick={() => navigate("/")}>Course finder</button>
            </li>
            <li className="footer-icon-desc-text">
              {" "}
              <button onClick={() => navigate("/services")}>Services</button>
            </li>
            <li className="footer-icon-desc-text">
              <button onClick={() => navigate("/language-prep")}>
                Language prep
              </button>
            </li>
            <li className="footer-icon-desc-text">
              {" "}
              <button onClick={() => navigate("/about-us")}>About Us</button>
            </li>
          </ul>
        </div>
        <div className="footer-our-services-container">
          <h4 className="font-semibold mb-3 footer-section-header-text">
            Our Services
          </h4>
          <ul className="space-y-1">
            <li className="footer-icon-desc-text cursor-pointer">
              <button onClick={() => navigate("/personalised-guidence/:1")}>
                Personalized Guidance
              </button>
            </li>
            <li className="footer-icon-desc-text cursor-pointer">
              <button onClick={() => navigate("/end-to-end-app-service/1")}>
                End-to-End Application Service
              </button>
            </li>
            <li className="footer-icon-desc-text cursor-pointer">
              <button onClick={() => navigate("/university-preparation/1")}>
                University Preparation
              </button>
            </li>
            <li className="footer-icon-desc-text cursor-pointer">
              <button onClick={() => navigate("/phd-application-mentorship/1")}>
                PhD Application Mentorship
              </button>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3 footer-section-header-text">
            Contact Information
          </h4>
          <p className="footer-icon-desc-text">
            17 Hanover Square, London W1S 1BN
          </p>
          <p className="footer-icon-desc-text">+44 20 7277 6666</p>
          <p className="footer-icon-desc-text"><a href="mailto:info@globalstudyin.com" className="underline footer-icon-desc-text">
            info@globalstudyin.com
          </a></p>
        </div>
      </div>
      <div className="footer-reserved-text text-center text-gray-400 mt-8 footer-bottom-text flex flex-col items-center gap-1">
        <span className="block">&copy; 2026 Global StudyIn All rights reserved.</span>
      </div>
    </footer>
  );
}
